import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InvoiceLineItems, invoiceItem } from '../../types/invoice';
import { InvoiceService } from '../../services/invoice/invoice.service';

@Component({
  selector: 'app-invoice-line-items',
  templateUrl: './invoice-line-items.component.html',
  styleUrl: './invoice-line-items.component.scss'
})
export class InvoiceLineItemsComponent {

  @Output() invoiceLineItemsChanged = new EventEmitter<InvoiceLineItems[]>();
  @Input() locator: any;
  @Input() location!: string;
  @Input() suite!: string;
  @Input() account!: string;
  // If any line item type should be hidden from selection. Default to MONTHLY because we assume that non-monthly
  // line items will be selected.
  @Input() typeToHide!: string;
  @Input() allowNotes!: boolean;

  availableLineItems!: Array<any>;
  allAvailableLineItems!: Array<any>;
  available_invoice_items!: invoiceItem[];
  @Input() items: InvoiceLineItems[] = [];
  existingItemsImported = false;

  noSelectionMessage = 'Please select a parking service';

  constructor(
    private invoiceService: InvoiceService,
  ) { }

  ngOnInit(): void {

    // If not set then get the tag properties
    if (typeof this.locator === 'undefined') {
      this.locator = {
        location: this.location,
        suite: this.suite,
        account: this.account,
      };
    }

    // Determine what type of line items should be hidden from selection
    // Default to hiding MONTHLY unless specified otherwise. Specify NONE to see all items
    this.typeToHide = (typeof this.typeToHide === 'undefined') ? 'MONTHLY' : this.typeToHide.toUpperCase();

    this.invoiceService.getTenant(this.locator.location, this.locator.suite, this.locator.account).subscribe(data => {
      this.handleResponse(data)
    });
  }

  handleResponse(data: any) {
    this.availableLineItems = [];
    this.allAvailableLineItems = [];

    let counter = 0;

    this.available_invoice_items = data.data.available_invoice_items;

    // If the unitprice is already formatted then remove the currency formatting
    this.available_invoice_items.forEach(v => {
      v.unitprice = this.stripCurrency(v.unitprice);
    });

    // The first item in the list is always a display that no item is selected.
    this.availableLineItems.push({
      value: this.noSelectionMessage,
      label: this.noSelectionMessage
    })
    counter += 1;

    for (let item of data.data.available_invoice_items) {
      // We only want to make invoices for items which are not monthly parking services.

      let lineItem = {
        code: item.code,
        value: item.description,
        label: item.description,
        type: item.type,

      };
      // Keep a list of all the available line items
      this.allAvailableLineItems.push(lineItem);

      // Keep a list of the line items the parent indicates should be available.
      // Show this item if it is not a type to hide from selection
      if (item.type.toUpperCase() !== this.typeToHide) {
        this.availableLineItems.push(lineItem);
        counter += 1;
      }
    }

    let lineItemsData = Object.assign({}, data.data);
    lineItemsData['availableLineItems'] = this.allAvailableLineItems;
    this.invoiceService.tenantSource.next(lineItemsData);
  }

  addLineItem() {

    this.items.push({
      qty: 0,
      desc: '',
      rate: 0,
      amount: 0,
      notes: ''
    });

  }

  removeLineItem(rowIndex: number) {
    this.items.splice(rowIndex, 1);
    this.invoiceLineItemsChanged.emit(this.removePlaceHolderItems(this.items));
  }

  changeLineItem(event: any, rowData: any) {

    let selected = event.value;

    for (let item of this.available_invoice_items) {
      if (item.description === selected) {

        if (isNaN(Number(item.unitprice))) {
          rowData.rate = item.unitprice.replace('$', '');
        } else {
          rowData.rate = item.unitprice;
        }

        rowData.type = item.type;

      }

      // If no item was selected zero out the line
      if (selected == this.noSelectionMessage) {
        rowData.rate = 0;
      }

    }

    rowData.amount = rowData.rate * rowData.qty;

    // Tell the parent what the current items are and recalculate the total
    this.invoiceLineItemsChanged.emit(this.removePlaceHolderItems(this.items));

  }

  qtyLostFocus(event: any, rowData: any) {

    let qty = parseInt(rowData.qty, 10);

    // Is the converted value an int and
    // does it match the previous value (loose comparison)
    if (Number.isNaN(qty) || qty != rowData.qty) {
      qty = 0;
      rowData.qty = 0;
    }

    // If converted value isn't an int then set back to 0
    if (!Number.isInteger(qty)) {
      rowData.qty = 0;
    }

    // Only allow positive integers
    if (qty < 0) {
      rowData.qty = 0;
    }

    // Sum the row if possible
    rowData.amount = rowData.rate * rowData.qty;

    // Tell the parent what the current items are and recalculate the total
    this.invoiceLineItemsChanged.emit(this.removePlaceHolderItems(this.items));

    return;
  }

  /*
  Remove any items from the list that are just placeholders
   */
  removePlaceHolderItems(items: InvoiceLineItems[]) {

    const cleanedItems: any = [];

    for (const item of items) {

      if (item.desc !== '') {
        cleanedItems.push(item);
      }

    }

    return cleanedItems;

  }

  stripCurrency(v: any) {

    // If the variable is a string it should have this function
    if (typeof v.replace === 'function') {
      v = v.replace('$', '');
      v = v.replace(',', '');
    } else {
      // Variable is a number and don't have a replace method
      v = String(v);
    }

    return v;

  }
}
